<!-- 申请新商品 -->
<template>
  <div class="apply">
    <back />

    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="170px" class="demo-ruleForm">
      <!-- 1.确定商品类目 -->
      <div class="first">
        <div class="titles">
          <div class="title">1、确定商品类目</div>
        </div>
        <el-row class="dialog_row">
          <el-col :span="8">
            <el-form-item label="一级类目" prop="firstLevelLabel">
              <el-select v-model="ruleForm.firstLevelLabel" placeholder="请选择" clearable @change="handleClear">
                <el-option v-for="item in firstOption" :key="item.value" :label="item.label" :value="item.value"
                  @click.native="handleSelectFirstLevel(item)"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="二级类目" prop="secondLevelLabel">
              <el-select v-model="ruleForm.secondLevelLabel" placeholder="请选择" clearable filterable>
                <el-option v-for="item in secondOption" :key="item.value" :label="item.label" :value="item.value"
                  @click.native="handleSelectSecondLevel(item)"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="dialog_row input-padding">
          <el-col :span="15">
            <el-input :value="combinedValue" readonly></el-input>
          </el-col>
        </el-row>
        <el-row class="dialog_row">
          <el-col :span="8">
            <el-form-item label="商品类型" prop="productType">
              <el-select v-model="ruleForm.productType" placeholder="请选择" clearable>
                <el-option v-for="item in productTypeOption" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="分区类型" prop="zoneType">
              <el-select v-model="ruleForm.zoneType" placeholder="请选择" clearable>
                <el-option v-for="item in zoneTypeOption" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- 2.基本信息 -->
      <div class="second">
        <div class="title">2、基本信息</div>
        <el-row class="dialog_row_second">
          <el-col :span="8">
            <el-form-item class="item" label="品牌" prop="brand">
              <el-input v-model="ruleForm.brand" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item class="item" label="规格" prop="specs">
              <div class="specs">
                <el-input v-model="ruleForm.scale" placeholder="请输入"></el-input>
                <el-select v-model="ruleForm.unit" placeholder="选择单位" @change="changeUnits" clearable>
                  <el-option v-for="(item, index) in units" :key="index" :label="item" :value="item"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item class="item" label="售价(元)" prop="salePrice">
              <el-input v-model="ruleForm.salePrice" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="item" label="商品名称" prop="productName">
              <el-input v-model="ruleForm.productName" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item class="item" label="保质期(天)" prop="validityPeriod">
              <el-input v-model="ruleForm.validityPeriod" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item class="item" label="划线价(元)" prop="linePrice">
              <el-input v-model="ruleForm.linePrice" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="item" label="厂家" prop="factoryName">
              <el-input v-model="ruleForm.factoryName" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item class="item" label="商品条形码" prop="barCode">
              <el-input v-model="ruleForm.barCode" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="dialog_row_second">
          <el-col :span="22">
            <el-form-item label="商品介绍" prop="introduction">
              <vue-word-editor v-model="ruleForm.introduction" :config="config" ref="wordeditor"></vue-word-editor>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- 3.商品图片 -->
      <div class="second">
        <div class="title">3、商品图片</div>
        <el-row class="dialog_row_second">
          <el-form-item class="item logo_pic" label="商品图片" prop="picUrl1">
            <div class="pic-row">
              <div class="pic">
                <el-upload class="logo_uploader" accept=".png,.jpeg,.jpg" name="multipartFile" :action="action"
                  :show-file-list="false" :on-success="handleSuccess1" :before-upload="beforeUploads"
                  :on-remove="handleRemoveLogo1" :disabled="ruleForm.picUrl1 ? true : false">
                  <img v-if="ruleForm.picUrl1" :src="ruleForm.picUrl1" class="logoimg">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <i v-if="ruleForm.picUrl1" class="delpic delpic1 el-icon-error" @click="handleRemoveLogo1"></i>
              </div>
              <div class="pic">
                <el-upload class="logo_uploader" accept=".png,.jpeg,.jpg" name="multipartFile" :action="action"
                  :show-file-list="false" :on-success="handleSuccess2" :before-upload="beforeUploads"
                  :on-remove="handleRemoveLogo2" :disabled="ruleForm.picUrl2 ? true : false">
                  <img v-if="ruleForm.picUrl2" :src="ruleForm.picUrl2" class="logoimg">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <i v-if="ruleForm.picUrl2" class="delpic delpic2 el-icon-error" @click="handleRemoveLogo2"></i>
              </div>
              <div class="pic">
                <el-upload class="logo_uploader" accept=".png,.jpeg,.jpg" name="multipartFile" :action="action"
                  :show-file-list="false" :on-success="handleSuccess3" :before-upload="beforeUploads"
                  :on-remove="handleRemoveLogo3" :disabled="ruleForm.picUrl3 ? true : false">
                  <img v-if="ruleForm.picUrl3" :src="ruleForm.picUrl3" class="logoimg">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <i v-if="ruleForm.picUrl3" class="delpic delpic3 el-icon-error" @click="handleRemoveLogo3"></i>
              </div>
            </div>

          </el-form-item>
        </el-row>
      </div>

      <!-- 4.分账设置 -->
      <div class="second">
        <div class="title">4、分账设置</div>
        <el-row class="dialog_row_second">
          <el-col :span="8">
            <el-form-item class="item" label="门店分账比例(%)" prop="distributionRatio">
              <el-input v-model="ruleForm.distributionRatio" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="submit-btn">
        <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
      </div>
    </el-form>

  </div>
</template>

<script>
import VueWordEditor from "vue-word-editor"
import "quill/dist/quill.snow.css"
export default {
  components: {
    VueWordEditor
  },
  data() {
    return {
      productId: null,
      firstOption: [], // 一级类目下拉框
      secondOption: [], // 二级类目下拉框
      productTypeOption: [{
        label: '免费领',
        value: 1
      },
      {
        label: '优惠品',
        value: 2
      },
      {
        label: '热销品',
        value: 3
      },
      ], // 商品类型下拉框
      zoneTypeOption: [{
        label: '文创专区',
        value: 1
      },
      {
        label: '帮扶专区',
        value: 2
      },
      ], // 分区类型下拉框
      ruleForm: {
        firstLevelLabel: '', // 一级类目label
        firstLevelValue: '', // 一级类目Value
        secondLevelLabel: '', // 二级类目label
        secondLevelValue: '', // 二级类目Value
        productType: '', // 商品类型
        zoneType: '', // 分区类型

        brand: '', // 品牌
        productName: '', // 商品名称
        factoryName: '', // 厂家
        scale: '', // 规格
        unit: '', // 单位
        validityPeriod: '', // 保质期
        barCode: '', // 商品条形码
        salePrice: '', // 售价
        linePrice: '', // 划线价
        introduction: '', // 商品介绍

        // 图片
        picUrl1: '',
        picUrl2: '',
        picUrl3: '',

        // 分账比例
        distributionRatio: '',
      },
      rules: {
        firstLevelLabel: [{
          required: true,
          message: '请选择一级类目',
          trigger: 'blur'
        }],
        secondLevelLabel: [{
          required: true,
          message: '请选择二级类目',
          trigger: 'blur'
        }],
        productType: [{
          required: true,
          message: '请选择商品类型',
          trigger: 'blur'
        }],
        brand: [{
          required: true,
          message: '请填写品牌',
          trigger: 'blur'
        }],
        productName: [{
          required: true,
          message: '请填写商品名称',
          trigger: 'blur'
        }],
        factoryName: [{
          required: true,
          message: '请填写厂家',
          trigger: 'blur'
        }],
        specs: [{
          required: true,
          validator: this.validateSpecs,
          trigger: 'blur,change'
        }],
        unit: [{
          required: true,
          message: '请选择',
          trigger: 'blur'
        }],
        scale: [{
          required: true,
          message: '请选择',
          trigger: 'blur'
        }, {
          pattern: /^\d+(\.\d{1,2})?$/,
          message: '只能输入数字，最多保留两位小数',
          trigger: 'blur'
        }],
        validityPeriod: [{
          required: true,
          message: '请填写保质期',
          trigger: 'blur'
        }, {
          pattern: /^\d+(\.\d{1,2})?$/,
          message: '只能输入数字，最多保留两位小数',
          trigger: 'blur'
        }],
        barCode: [{
          required: true,
          message: '请填写商品条形码',
          trigger: 'blur'
        }, {
          pattern: /^[a-zA-Z0-9]+(?:\.[0-9]{1,2})?$/,
          message: '只能输入英文和数字',
          trigger: 'blur'
        }],
        salePrice: [{
          required: true,
          message: '请填写售价',
          trigger: 'blur'
        }, {
          pattern: /^\d+(\.\d{1,2})?$/,
          message: '只能输入数字，最多保留两位小数',
          trigger: 'blur'
        }],

        linePrice: [{
          pattern: /^\d+(\.\d{1,2})?$/,
          message: '只能输入数字，最多保留两位小数',
          trigger: 'blur'
        }],
        picUrl1: [{
          required: true,
          message: '请上传',
          trigger: 'blur'
        }],
        distributionRatio: [{
          required: true,
          message: '请输入',
          trigger: 'blur'
        }, {
          pattern: /^(100(\.0+)?|(\d{1,2}(\.\d+)?))$/,
          message: '请输入0到100之间的数字',
          trigger: ['blur', 'change']
        }]

      },

      // 图片上传
      fileList: [],
      action: this.$axios.defaults.baseURL + this.$api.uploadFile,

      units: ["g", "kg", "ml", "l", "件", "双", "盒", "包", "个", "片", "英寸", "寸"],
      config: {
        placeholder: "请输入内容",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], // toggled buttons
            ["blockquote", "code-block"],
            ["link", "image"],
            [{
              header: 1
            }, {
              header: 2
            }], // custom button values
            [{
              list: "ordered"
            }, {
              list: "bullet"
            }, {
              list: "check"
            }],
            [{
              script: "sub"
            }, {
              script: "super"
            }], // superscript/subscript
            [{
              indent: "-1"
            }, {
              indent: "+1"
            }], // outdent/indent
            [{
              direction: "rtl"
            }], // text direction
          ],
        },
        // 上传图片的配置
        uploadImage: {
          url: this.$axios.defaults.baseURL + this.$api.uploadFile,
          name: "multipartFile",
          headers: this.getToken(),
          // res是结果，insert方法会把内容注入到编辑器中，res.data.url是资源地址
          uploadSuccess: (res, insert) => {
            insert(res.data.result.fileUrl)
          },
          showProgress: false,
        },
      },
    }
  },
  created() {
    if (this.$route.query.productId) {
      this.productId = this.$route.query.productId;
      this.getDetails();
    }
    this.getCategoryInfoList();
  },
  methods: {
    getToken() {
      return {
        Token: JSON.parse(localStorage.getItem("vuex")).token,
      }
    },
    // 获取分类下拉列表
    getCategoryInfoList() {
      this.$axios.get(this.$api.getCategoryList, {
        params: {
          page: 1,
          pageSize: 9999,
        }
      }).then((res) => {
        if (res.code === 100) {
          res.result.list.forEach(item => {
            this.firstOption.push({
              label: item.categoryName,
              value: item.categoryId,
              children: item.children
            });
          });
        }
      }).catch(err => {
        console.log(err);
      })
    },
    // 获取详情
    getDetails() {
      this.$axios.get(this.$api.selectProductDetail, {
        params: {
          productId: this.productId
        }
      })
        .then((res) => {
          if (res.code == 100) {
            let row = res.result;
            this.$set(this.ruleForm, 'firstLevelLabel', row.firstCategoryName);
            this.$set(this.ruleForm, 'firstLevelValue', row.firstCategoryId);
            this.$set(this.ruleForm, 'secondLevelLabel', row.secondCategoryName);
            this.$set(this.ruleForm, 'secondLevelValue', row.secondCategoryId);
            this.$set(this.ruleForm, 'brand', row.brand);
            this.$set(this.ruleForm, 'productName', row.productName);
            this.$set(this.ruleForm, 'factoryName', row.factoryName);
            this.$set(this.ruleForm, 'scale', row.specsValue);
            this.$set(this.ruleForm, 'unit', row.specsUnit);
            this.$set(this.ruleForm, 'barCode', row.barCode);
            this.$set(this.ruleForm, 'validityPeriod', row.validityPeriod);
            this.$set(this.ruleForm, 'salePrice', row.salePrice);
            this.$set(this.ruleForm, 'linePrice', row.linePrice);
            this.$set(this.ruleForm, 'picUrl1', row.picList[0]);
            this.$set(this.ruleForm, 'picUrl2', row.picList[1]);
            this.$set(this.ruleForm, 'picUrl3', row.picList[2]);
            this.$refs.wordeditor.editor.root.innerHTML = row.introduction
            // 商品类型....
            this.$set(this.ruleForm, 'productType', row.productType);
            this.$set(this.ruleForm, 'zoneType', row.zoneType);
            // 门店分账比例....
            this.$set(this.ruleForm, 'distributionRatio', row.commissionRate);
          }
        })
    },
    validateSpecs(rule, value, callback) {
      let isValid = false;
      isValid = this.ruleForm.scale && this.ruleForm.unit
      if (isNaN(this.ruleForm.scale)) {
        callback(new Error('规格只能为数字'));
      }
      if (isValid) {
        callback();
      } else {
        callback(new Error('请填写规格！'));
      }
    },
    changeUnits(val) {
      if (['件', '双', '盒', '包', "个", "片", "英寸", "寸"].includes(val)) {
        // 仅当 scale 没有值时才设置为 '1'
        if (!this.ruleForm.scale) {
          this.$set(this.ruleForm, 'scale', '1');
        }
      }
      if (val == '') {
        this.ruleForm.scale = ""
      }
    },
    // 表单校验
    submitForm(formName) {
      this.ruleForm.introduction = this.$refs.wordeditor.editor.root.innerHTML
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.$route.query.productId) {
            // 如果存在 this.$router.query.productId，则调用修改接口
            this.$axios.post(this.$api.updateProductInfo, {
              productId: Number(this.$route.query.productId), // 更新的商品 ID
              firstCategoryId: this.ruleForm.firstLevelValue, // 一级分类id
              firstCategoryName: this.ruleForm.firstLevelLabel, // 一级分类Name
              secondCategoryId: this.ruleForm.secondLevelValue || null, // 二级分类id
              secondCategoryName: this.ruleForm.secondLevelLabel || null, // 二级分类Name
              barCode: this.ruleForm.barCode || null, // 商品条形码
              brand: this.ruleForm.brand || null, // 品牌
              factoryName: this.ruleForm.factoryName || null, // 厂名
              introduction: this.ruleForm.introduction || null, // 商品介绍
              linePrice: this.ruleForm.linePrice || null, // 划线价
              productName: this.ruleForm.productName || null, // 商品名称
              salePrice: this.ruleForm.salePrice || null, // 售价
              specsValue: Number(this.ruleForm.scale) || null, // 规格
              specsUnit: this.ruleForm.unit || null, // 单位
              validityPeriod: this.ruleForm.validityPeriod || null, // 保质期
              urlList: [this.ruleForm.picUrl1, this.ruleForm.picUrl2, this.ruleForm.picUrl3] || null, // 商品图片
              productType: this.ruleForm.productType || null, // 商品类型
              zoneType: this.ruleForm.zoneType || null, // 分区类型
              commissionRate: this.ruleForm.distributionRatio || null, // 分账比例
              // 门店分账比例....
            }).then((res) => {
              if (res.code == 100) {
                this.$message.success(res.desc);
                this.$router.go(-1);
                this.resetForm();
              }
            }).catch(() => {
              this.$message.error('编辑失败');
            });
          } else {
            // 否则调用添加接口
            this.$axios.post(this.$api.saveProductInfo, {
              firstCategoryId: this.ruleForm.firstLevelValue, // 一级分类id
              firstCategoryName: this.ruleForm.firstLevelLabel, // 一级分类Name
              secondCategoryId: this.ruleForm.secondLevelValue || null, // 二级分类id
              secondCategoryName: this.ruleForm.secondLevelLabel || null, // 二级分类Name
              barCode: this.ruleForm.barCode || null, // 商品条形码
              brand: this.ruleForm.brand || null, // 品牌
              factoryName: this.ruleForm.factoryName || null, // 厂名
              introduction: this.ruleForm.introduction || null, // 商品介绍
              linePrice: this.ruleForm.linePrice || null, // 划线价
              productName: this.ruleForm.productName || null, // 商品名称
              salePrice: this.ruleForm.salePrice || null, // 售价
              specsValue: Number(this.ruleForm.scale) || null, // 规格
              specsUnit: this.ruleForm.unit || null, // 单位
              validityPeriod: this.ruleForm.validityPeriod || null, // 保质期
              urlList: [this.ruleForm.picUrl1, this.ruleForm.picUrl2, this.ruleForm.picUrl3] || null, // 商品图片
              productType: this.ruleForm.productType || null, // 商品类型
              zoneType: this.ruleForm.zoneType || null, // 分区类型
              commissionRate: this.ruleForm.distributionRatio || null, // 分账比例
            }).then((res) => {
              if (res.code == 100) {
                this.$message.success(res.desc);
                this.$router.go(-1);
                this.resetForm();
              }
            }).catch(() => {
              this.$message.error('添加失败');
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 重置表单
    resetForm() {
      this.ruleForm = {};
      this.$refs.ruleForm.resetFields();
      this.$refs.wordeditor.editor.root.innerHTML = ""
    },
    beforeUploads(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/jpg" || file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message.error("图文只支持jpg、png、jpeg，请调整格式再上传!");
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isJPG && isLt5M;
    },
    handleRemoveLogo1() {
      this.ruleForm.picUrl1 = ""
    },
    handleSuccess1(res) {
      if (res.code == 100) {
        this.ruleForm.picUrl1 = res.result.fileUrl;
      } else {
        this.$message({
          showClose: true,
          message: res.desc,
          type: "error",
        });
      }
    },
    handleRemoveLogo2() {
      this.ruleForm.picUrl2 = ""
    },
    handleSuccess2(res) {
      if (res.code == 100) {
        this.ruleForm.picUrl2 = res.result.fileUrl;
      } else {
        this.$message({
          showClose: true,
          message: res.desc,
          type: "error",
        });
      }
    },
    handleRemoveLogo3() {
      this.ruleForm.picUrl3 = ""
    },
    handleSuccess3(res) {
      if (res.code == 100) {
        this.ruleForm.picUrl3 = res.result.fileUrl;
      } else {
        this.$message({
          showClose: true,
          message: res.desc,
          type: "error",
        });
      }
    },
    // 下拉选择一级类目
    handleSelectFirstLevel(item) {
      this.ruleForm.firstLevelLabel = item.label;
      this.ruleForm.firstLevelValue = item.value;
      const selectedFirstLevel = this.firstOption.find(option => option.value == item.value);
      if (selectedFirstLevel && selectedFirstLevel.children) {
        selectedFirstLevel.children.forEach(child => {
          this.secondOption.push({
            label: child.categoryName,
            value: child.categoryId
          });
        });
      }
    },
    // 清空一级 置空二级
    handleClear() {
      this.ruleForm.firstLevelLabel = "";
      this.ruleForm.firstLevelValue = "";
      // 在清空一级类目后，清除该下拉框的校验状态
      this.$refs['ruleForm'].clearValidate('firstLevelLabel');
      // 清空二级类目选项
      this.secondOption = [];
      this.ruleForm.secondLevelLabel = "";
      this.ruleForm.secondLevelValue = "";
    },

    // 下拉选择二级类目
    handleSelectSecondLevel(item) {
      this.ruleForm.secondLevelLabel = item.label;
      this.ruleForm.secondLevelValue = item.value;
    },

  },
  computed: {
    combinedValue() {
      return `已选类目：${this.ruleForm.firstLevelLabel}  ${this.ruleForm.secondLevelLabel}`
    }
  }

}
</script>

<style lang="scss" scoped>
// common
.dialog_row {
  ::v-deep .el-form-item__label {
    color: #272727;
    font-size: 16px;
    padding-right: 30px;
  }

  ::v-deep .el-select {
    width: 300px;
  }
}

.submit-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.apply {

  // 1.确定商品类目
  .first {
    margin: 0 20px;

    .titles {
      display: flex;
      align-items: center;

      .title {
        font-size: 20px;
        margin-bottom: 30px;
      }
    }

    .input-padding {
      margin-bottom: 30px;
      padding-left: 50px;
    }
  }

  // 2.基本信息
  .second {
    margin: 30px 20px;

    .title {
      font-size: 20px;
      margin-bottom: 30px;
    }

    .specs {
      display: flex;

      .el-input {
        margin-right: 5px;
      }
    }

    .dialog_row_second {
      .item {
        margin-right: 10px;
      }

      ::v-deep .el-form-item__label {
        color: #272727;
        font-size: 16px;
        padding-right: 30px;
      }

      ::v-deep .el-select {
        width: 240px;
      }
    }
  }

  // 图片
  .logo_pic {
    position: relative;

    ::v-deep .el-form-item__content {
      width: 100px;
      height: 100px;
    }

    .pic-row {
      display: flex;

      .pic {
        margin-right: 15px;

        .logo_uploader {
          ::v-deep .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
          }

          ::v-deep .el-upload:hover {
            border-color: #069BBC;
          }

          .avatar-uploader-icon {
            font-size: 28px;
            color: #069BBC;
            width: 100px;
            height: 100px;
            line-height: 100px;
            text-align: center;
          }

          .logoimg {
            width: 100px;
            height: 100px;
            display: block;
            object-fit: cover;
          }
        }
      }
    }

    .delpic {
      position: absolute;
      top: -12px;
      color: red;
      font-size: 20px;
      cursor: pointer;
    }

    .delpic1 {
      right: -15px;
    }

    .delpic2 {
      right: -134px;
    }

    .delpic3 {
      right: -250px;
    }
  }

  #vue-editor-wrapper {
    height: 200px;
  }
}
</style>
